import OnlyHeader from "components/Headers/OnlyHeader";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { updateContestStatus } from "store/actions/authAction";
import { updatePasswordUser } from "store/actions/authAction";

const Setting = () => {
  let dispatch = useDispatch();
  const { user } = useSelector((state) => state?.auth);
  const [updatePassword, setUpdatePassword] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });
  const [loader, setLoader] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState(false);

  const handleChange = (e) => {
    let { name, value } = e.target;
    setUpdatePassword((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdateContestStatus = () => {
    const updatedStatus = !user?.showContests;
    setUpdatingStatus(true);
    dispatch(
      updateContestStatus({ uid: user?.id, showContests: updatedStatus })
    ).finally(() => setUpdatingStatus(false));
  };

  const updatePasswordClick = (e) => {
    e.preventDefault();
    if (updatePassword.newPassword !== updatePassword.confirmNewPassword) {
      toast.error("Passwords do not match. Please enter the same password.");
    } else if (updatePassword.newPassword == updatePassword.currentPassword) {
      toast.warning("You Used Current Password.");
    } else if (updatePassword.newPassword.length < 6) {
      toast.warning("Password must be at least 7 characters long.");
    } else {
      setLoader(true);
      let obj = {
        currentPassword: updatePassword.currentPassword,
        newPassword: updatePassword.newPassword,
      };
      dispatch(
        updatePasswordUser(obj, (res) => {
          setLoader(false);
          if (res == "success") {
            setUpdatePassword({
              currentPassword: "",
              newPassword: "",
              confirmNewPassword: "",
            });
          }
        })
      );
    }
  };

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row className="mb-5">
          <div className="col h-100">
            <Card className="shadow p-4 h-100">
              <h1 className="text-center my-4">Setting</h1>
              <Form onSubmit={updatePasswordClick}>
                <Row lg="3" md="2" xs="1" className="mb-4">
                  <Col lg="4" md="6" className="my-1">
                    <Label>County</Label>
                    <Input
                      required
                      placeholder="Your Current County"
                      value={user?.county}
                      name="county"
                      onChange={handleChange}
                      disabled
                    />
                  </Col>
                  <Col lg="4" md="6" className="my-1">
                    <Label>State</Label>
                    <Input
                      required
                      placeholder="Your Current State"
                      value={user?.state}
                      name="state"
                      onChange={handleChange}
                      disabled
                    />
                  </Col>
                  <Col lg="4" md="6" className="my-1">
                    <Label>School Name</Label>
                    <Input
                      required
                      placeholder="Your Current School"
                      value={user?.instituteName}
                      name="school"
                      onChange={handleChange}
                      disabled
                    />
                  </Col>
                  <Col lg="4" md="6" className="my-1">
                    <Label>Current Password</Label>
                    <Input
                      required
                      placeholder="Your Current Password"
                      value={updatePassword.currentPassword}
                      name="currentPassword"
                      onChange={handleChange}
                    />
                  </Col>
                  <Col lg="4" md="6" className="my-1">
                    <Label className="">New Password</Label>
                    <Input
                      required
                      placeholder="New Password"
                      value={updatePassword.newPassword}
                      name="newPassword"
                      onChange={handleChange}
                    />
                  </Col>
                  <Col lg="4" md="6" className="my-1">
                    <Label className="">Confirm New Password</Label>
                    <Input
                      required
                      placeholder="Confirm New Password"
                      value={updatePassword.confirmNewPassword}
                      name="confirmNewPassword"
                      onChange={handleChange}
                    />
                  </Col>
                  <Col lg="4" md="6" className="my-3 ml-4">
                    <Label check>
                      <Input
                        type="checkbox"
                        name="school"
                        onChange={handleUpdateContestStatus}
                        checked={user?.showContests}
                        style={{
                          width: "16px",
                          height: "16px",
                          cursor: "pointer",
                        }}
                        disabled={updatingStatus}
                      />
                      <span className="ml-2">Show Contests</span>
                    </Label>
                  </Col>
                  <Col lg="12" md="12" className="d-block mt-3">
                    <Button color="primary" type="submit">
                      {loader ? <Spinner size="sm" /> : "Update Password"}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Setting;
